<template>
  <section class="recordDetail-container">
    <base-header
      v-bind="headers"
      @handleBack="handleClickBack"
    />
    <div class="title">{{detail.title}}</div>
    <div class="content" v-html="detail.content"></div>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
export default {
  name: '',
  mixins: [baseHeader],
  data () {
    return {
      detail: {},
      headers: {
        buttons: [
          {
            type: 'Back',
            text: '返回',
            icon: 'fanhui'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    fetchOabuinessRecordDetail (data) {
      this.$request.fetchOabuinessRecordDetail(data).then(res => {
        if (res.code === 200) {
          this.detail = res.data
        }
      })
    },
    handleClickBack () {
      this.removeTab(this.$route.fullPath)
      this.$router.replace({ name: 'oabusinessRecordIndex' })
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.fetchOabuinessRecordDetail({
      id: id
    })
  },
  activated () {
    const { id } = this.$route.query
    this.fetchOabuinessRecordDetail({
      id: id
    })
  }
}
</script>
<style lang="scss" scoped>
.recordDetail-container{
  .title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .content {
    font-size: 24px;
    word-break: break-all;
    img {
      max-width: 100%;
    }
  }
}
</style>
